import { useContext, useMemo } from 'react';
import {
  IEditMenuAction,
  IEditMenuActionParams,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import {
  isAttestButtonHidden,
  isSendbackButtonDisabled,
} from '../Utils/BokforderUtils';
import { FranvaroContext } from '../../../../SystemAdministration/ObjektVyer/User/Context/FranvaroContext/FranvaroContext';

export const useBokforderEditMenuSendBackButton = (
  queriesLoading: boolean,
  userID: string | null,
  setSendBackDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
): IEditMenuAction => {
  const franvaroContext = useContext(FranvaroContext);

  return useMemo(
    () => ({
      id: 'sendBackButton',
      isDisabled: (params: IEditMenuActionParams) =>
        (queriesLoading || isSendbackButtonDisabled(userID)(params)) ?? false,
      disableReason: (params: IEditMenuActionParams) =>
        isSendbackButtonDisabled(userID)(params),
      isHidden: isAttestButtonHidden(
        userID ?? '',
        franvaroContext.franvaroReservForData
      ),
      label: 'Skicka Tillbaka',
      shortLabel: 'Returnera',
      onClick: () => setSendBackDialogOpen(true),
      icon: 'turn_left_outlined',
      hideIconIfNotFloating: true,
    }),
    [
      franvaroContext.franvaroReservForData,
      queriesLoading,
      setSendBackDialogOpen,
      userID,
    ]
  );
};
